import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom';



import { GoogleMapScript } from './components/googleMapScript';
import HomePage from './views/homePage';
import SettingsPage from './views/settingsPage';
import LoginPage from './views/loginPage';
import ListPage from './views/listPage';
import FormPage from './views/formPage';
import EbayPage from './views/ebayPage';
import EbayCreateOffer from './views/ebayCreateOffer';
import Order from './views/order';
import { getSiteConfig } from './siteConfig';
//const history = createHistory();


let promotedProductFields = [];
let popularProductFields = [];
let onOfferProductFields = [];
let specialOfferProductFields = [];


let vpOrderEmailFields = [];
let mpOrderEmailFields = [];
let newCustomerEmailFields = [];


for (let i = 0; i < 8; i++) {
    vpOrderEmailFields.push({
        name: `legalPersonOrderEmail[${i}]`,
        label: `Email #${i + 1}`,
        type: 'text',
        multilang: false,

        width: {
            desktop: 4,
            mobile: 12
        }
    });


    mpOrderEmailFields.push({
        name: `physicalPersonOrderEmail[${i}]`,
        label: `Email #${i + 1}`,
        type: 'text',
        multilang: false,

        width: {
            desktop: 4,
            mobile: 12
        }
    });
    newCustomerEmailFields.push({
        name: `newCustomerEmail[${i}]`,
        label: `Email #${i + 1}`,
        type: 'text',
        multilang: false,

        width: {
            desktop: 4,
            mobile: 12
        }
    });


    vpOrderEmailFields.push({
        type: 'offset',
        width: {
            desktop: 12,
            mobile: 12
        }
    })
    mpOrderEmailFields.push({
        type: 'offset',
        width: {
            desktop: 12,
            mobile: 12
        }
    })
    newCustomerEmailFields.push({
        type: 'offset',
        width: {
            desktop: 12,
            mobile: 12
        }
    })

}

for (let i = 0; i < 30; i++) {
    promotedProductFields.push({
        name: `promotedProducts[${i}]`,
        label: `Sifra #${i + 1}`,
        type: 'text',
        multilang: false,

        width: {
            desktop: 4,
            mobile: 12
        }
    });


    popularProductFields.push({
        name: `popularProducts[${i}]`,
        label: `Sifra #${i + 1}`,
        type: 'text',
        multilang: false,

        width: {
            desktop: 4,
            mobile: 12
        }
    });
    onOfferProductFields.push({
        name: `onOfferProducts[${i}]`,
        label: `Sifra #${i + 1}`,
        type: 'text',
        multilang: false,

        width: {
            desktop: 4,
            mobile: 12
        }
    });
    onOfferProductFields.push({
        name: `onOfferProductsMPCDiscount[${i}]`,
        label: `MPC Popust #${i + 1} [%]`,
        type: 'text',
        multilang: false,

        width: {
            desktop: 2,
            mobile: 12
        }
    });

    onOfferProductFields.push({
        name: `onOfferProductsVPCDiscount[${i}]`,
        label: `VPC Popust #${i + 1} [%]`,
        type: 'text',
        multilang: false,

        width: {
            desktop: 2,
            mobile: 12
        }
    });

    if (i < 6)
        specialOfferProductFields.push({
            name: `specialOfferProducts[${i}]`,
            label: `Sifra #${i + 1}`,
            type: 'text',
            multilang: false,

            width: {
                desktop: 4,
                mobile: 12
            }
        });

    promotedProductFields.push({
        type: 'offset',
        width: {
            desktop: 12,
            mobile: 12
        }
    })
    popularProductFields.push({
        type: 'offset',
        width: {
            desktop: 12,
            mobile: 12
        }
    })
    onOfferProductFields.push({
        type: 'offset',
        width: {
            desktop: 12,
            mobile: 12
        }
    })
    specialOfferProductFields.push({
        type: 'offset',
        width: {
            desktop: 12,
            mobile: 12
        }
    })

}

// Company data of this shop (config.Company), shown on the site, in mails and on the invoice
let companyFields = [
    ['Name', 'Naziv firme (npr. d.o.o. EXCALIBUR@)'],
    ['LegalName', 'Naziv za copyright (npr. AutoIn Excalibur@ d.o.o. Bijeljina)'],
    ['Street', 'Ulica i broj'],
    ['City', 'Poštanski broj i grad'],
    ['Country', 'Država (na fakturi)'],
    ['Place', 'Mjesto na fakturi (npr. Bijeljina)'],
    ['PlaceIn', 'Mjesto u padežu: "zaključen u ..." (npr. Bijeljini)'],
    ['Phone', 'Telefon'],
    ['Mobile', 'Mobilni (na fakturi)'],
    ['Viber', 'Viber broj (npr. +38765582516, prazno = bez dugmeta)'],
    ['Email', 'E-mail'],
    ['TaxIdLabel', 'Oznaka poreskog broja (JIB / PIB)'],
    ['TaxId', 'JIB / PIB'],
    ['VatNumber', 'PDV broj'],
    ['RegNumber', 'Matični broj'],
    ['BankAccount', 'Žiro račun i banka'],
    ['FacebookUrl', 'Facebook link'],
    ['InstagramUrl', 'Instagram link'],
].map(([name, label]) => ({
    name: `Company.${name}`,
    label: label,
    type: 'text',
    multilang: false,
    width: {
        desktop: 6,
        mobile: 12
    }
})).concat([
    {
        name: 'Company.HeaderLogoUrl',
        label: 'Logo u zaglavlju sajta (prazno = AutoIn logo)',
        type: 'file',
        multilang: false,
        width: {
            desktop: 6,
            mobile: 12
        }
    },
    {
        name: 'Company.InvoiceLogoUrl',
        label: 'Logo na narudžbenici (prazno = logo iz zaglavlja sajta)',
        type: 'file',
        multilang: false,
        width: {
            desktop: 6,
            mobile: 12
        }
    },
    {
        name: 'Company.DomainImageUrl',
        label: 'Slika domena ispod mape (prazno = www.autoin.ba)',
        type: 'file',
        multilang: false,
        width: {
            desktop: 6,
            mobile: 12
        }
    },
    {
        name: 'Company.PaymentSlipUrl',
        label: 'Slika uplatnice za žiralno plaćanje (prazno = uplatnica za BiH)',
        type: 'file',
        multilang: false,
        width: {
            desktop: 6,
            mobile: 12
        }
    }
]);

let formPages = [
    {
        title: 'Administratori',
        subtitle: '',
        link: '/admins',
        collection: 'admins',
        multilang: false,
        fields: [
            {
                name: 'username',
                label: 'Username',
                type: 'text',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'pk',
                label: 'Lozinka',
                type: 'password',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },

            {
                name: 'userRole',
                label: 'Tip admina',
                type: 'select',
                values: [
                    {
                        name: 'SUPERIOR',
                        value: 'super'
                    }, {
                        name: 'SIMPLE',
                        value: 'simple'
                    }, {
                        name: 'SPECIAL',
                        value: 'special'
                    },

                ],
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },

        ],
        linkedFields: [

        ]
    },
    {
        title: 'Partneri',
        subtitle: '',
        link: '/partners',
        collection: 'partners',
        multilang: false,
        fields: [
            {
                name: 'Name',
                label: 'Ime',
                type: 'text',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Image',
                label: 'Slika',
                type: 'file',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },
            {
                name: 'Position',
                label: 'Pozicija',
                type: 'text',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
        ],
        linkedFields: [

        ]
    },
    {
        title: 'Proizvodi na pocetnoj',
        subtitle: '',
        link: '/products-config',
        collection: 'productsConfig',

        multilang: false,
        fields: [
            {
                type: 'title',
                text: 'Izdvojeni'
            },

            ...promotedProductFields,
            {
                type: 'title',
                text: 'Popularni'
            },

            ...popularProductFields,

            {
                type: 'title',
                text: 'Na akciji'
            },


            ...onOfferProductFields,
            {
                type: 'title',
                text: 'Specijalna ponuda'
            },

            ...specialOfferProductFields

        ],
        linkedFields: [

        ]
    },

    {
        title: 'O nama',
        subtitle: '',
        link: '/aboutus',
        collection: 'aboutus',
        multilang: true,
        fields: [
            {
                name: 'companyData',
                label: 'Podaci o firmi',
                type: 'html',
                multilang: true,

                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Content',
                label: 'Tekst',
                type: 'html',
                multilang: true,

                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
        ],
        linkedFields: [

        ]
    },

    {
        title: 'Newsletter',
        subtitle: 'Configure newsletter',
        link: '/newsletters',
        collection: 'newsletters',
        multilang: false,
        fields: [
            {
                name: 'Title',
                label: 'Title',
                type: 'text',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            }, {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Image',
                label: 'Image',
                type: 'file',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            }, {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Text',
                label: 'Text',
                type: 'html',
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },
            {
                type: 'list',
                name: 'products',
                width: {
                    desktop: 4,
                    mobile: 12
                },

                fields: [
                    {
                        type: 'image',
                        name: 'Image',
                        width: {
                            desktop: 2,
                            mobile: 2
                        }
                    },
                    {
                        type: 'text',
                        name: 'Alias',
                        width: {
                            desktop: 4,
                            mobile: 4
                        }
                    },
                    {
                        type: 'text',
                        name: 'Name.de',
                        width: {
                            desktop: 4,
                            mobile: 4
                        }
                    },
                ],

            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                id: '342yh43hi234',
                type: 'search',
                label: 'Search products',
                collection: 'products',
                searchFields: ['Alias', 'Name.de'],
                fields: [
                    {
                        type: 'image',
                        name: 'Image'
                    },
                    {
                        type: 'text',
                        name: 'Alias'
                    },
                    {
                        type: 'text',
                        name: 'Name.de'
                    }
                ],
                limit: 10,
                onSelect: (scope, value) => {
                    console.log(value);
                    let fields = scope.state.fields;
                    let initialValues = scope.state.initialValues;
                    console.log(initialValues['products']);
                    if (!initialValues['products'])
                        initialValues['products'] = [];
                    initialValues['products'].push(value);
                    for (let i = 0; i < fields.length; i++) {
                        fields[i]._temp = new Date();

                    }
                    scope.setState({ initialValues: initialValues, fields: [] }, () => {
                        scope.forceUpdate();
                        scope.setState({ fields: fields });
                    });


                },
                width: {
                    desktop: 4,
                    mobile: 12
                }
            }, {
                type: 'spacer'
            },
        ],
        linkedFields: [

        ]
    },
    {
        title: 'Narudžba',
        subtitle: 'Pregled narudžbe',
        link: '/orders',
        collection: 'orders',
        multilang: false,
        fields: [
            {
                type: 'label',
                name: 'orderNumber',
                beforeText: 'Broj narudžbe: ',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            }, {
                type: 'label',
                name: 'Status',
                beforeText: 'Status: ',
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                type: 'label',
                name: 'DeliveryMethod.name',
                beforeText: 'Dostava: ',

                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                name: 'BillingMethod',
                beforeText: 'Način plaćanja: ',
                type: 'label',

                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                type: 'label',
                name: 'subtotal',
                beforeText: 'Iznos bez PDV-a: ',
                get afterText() { return ' ' + getSiteConfig().currency; },
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                type: 'label',
                name: 'tax',
                beforeText: 'Iznos PDV-a ',
                get afterText() { return ' ' + getSiteConfig().currency; },
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                type: 'label',
                name: 'total',
                beforeText: 'Iznos sa PDV: ',
                get afterText() { return ' ' + getSiteConfig().currency; },
                width: {
                    desktop: 4,
                    mobile: 12
                }

            },
            {
                type: 'spacer'
            },

            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },

            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },

            {
                type: 'title',
                text: 'Podešavanje fakture'
            },
            {
                name: 'FiscalNumber',
                label: 'Broj fiskalnog računa',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'Charged',
                label: 'Datum fakturisanja',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'Delivered',
                label: 'Datum isporuke',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'BillMaxDateToPay',
                label: 'Valuta plaćanja',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            }, {
                name: 'Warehouse',
                label: 'Skladište',
                type: 'select',
                values: [
                    {
                        name: '1 - MAGACIN',
                        value: '1 - MAGACIN'
                    }, {
                        name: '2 - VELEPRODAJA',
                        value: '2 - VELEPRODAJA'
                    }, {
                        name: '3 - MALOPRODAJA',
                        value: '3 - MALOPRODAJA'
                    },

                ],
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },

            {
                type: 'title',
                text: 'Adresa za obračun'
            },

            {
                name: 'BillingAddress.FirstName',
                label: 'Ime',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.LastName',
                label: 'Prezime',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.Street',
                label: 'Ulica',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.City',
                label: 'Grad',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 5,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.Zipcode',
                label: 'Poštanski broj',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 1,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.Company',
                label: 'Firma',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.EMail',
                label: 'EMail',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.Phone',
                label: 'Telefon',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.JIB',
                get label() { return getSiteConfig().company.TaxIdLabel || 'JIB'; },
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.PDV',
                label: 'PDV',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.MB',
                label: 'MB',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.TaxPayer',
                label: 'Obavezik PDV-a',
                type: 'select',
                values: [
                    {
                        name: 'NE',
                        value: '0'
                    }, {
                        name: 'DA',
                        value: '1'
                    }
                ],
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },


            {
                type: 'title',
                text: 'Adresa za isporuku'
            },

            {
                name: 'ShippingAddress.FirstName',
                label: 'Ime',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.LastName',
                label: 'Prezime',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.Street',
                label: 'Ulica',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                name: 'ShippingAddress.City',
                label: 'Grad',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 5,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.Zipcode',
                label: 'Poštanski broj',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 1,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.EMail',
                label: 'EMail',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.Phone',
                label: 'Telefon',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                type: 'spacer'
            },

            {
                type: 'button',
                text: 'Prikaži narudžbenicu',
                width: {
                    desktop: 3,
                    mobile: 12
                },
                onClick: (scope) => {
                    window.location = window.location.origin + '/order/' + scope.state.initialValues._id;
                }

            },
            {
                type: 'spacer'
            },
        ],
        linkedFields: [

        ]
    },
    {
        title: 'Proizvod',
        subtitle: 'Dodaj/Izmjeni proizvod',
        link: '/products',
        collection: 'products',
        multilang: true,
        fields: [
            {
                name: 'Alias',
                label: 'Šifra proizvoda',
                type: 'text',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BarCode',
                label: 'Bar kod',
                type: 'text',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                "type": "offset",
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'IsVisible',
                label: 'Proizvod je vidljiv u shopu',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'VisibleOnlyForUsers',
                label: 'Proizvod je vidljiv samo ulogovanim korisnicima',
                type: 'checkbox',
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                name: 'IsNew',
                label: 'Novo u ponudi',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'IsComingSoon',
                label: 'Uskoro (traka "USKORO" umjesto "NOVO")',
                type: 'checkbox',
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },

            /*{
                name: 'IsPromoted',
                label: 'Izdvojen proizvod',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'IsPopular',
                label: 'Popularan proizvod',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'OnOffer',
                label: 'Na akciji',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'SpecialOffer',
                label: 'Specijalna ponuda',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },*/
            {
                name: 'ProductForLegalPersons',
                label: 'Velprodajni prozivod',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                "type": "spacer"
            },
            {
                name: 'Image',
                label: 'Slika na početnoj',
                type: 'file',
                width: {
                    desktop: 3,
                    mobile: 12
                }
            }, {
                name: 'Images',
                label: 'Ostale slike',
                type: 'file-multiple',
                width: {
                    desktop: 9,
                    mobile: 12
                }
            }, {
                "type": "offset",
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Name',
                label: 'Naziv proizvoda',
                type: 'text',
                multilang: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'spacer',
            },
            {
                type: 'spacer',
            },
            {
                name: 'MinOrder',
                label: 'Minimalna narudzba (komada)',
                type: 'text',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'MinOrderPhysical',
                label: 'Minimalna narudzba (komada) MP',
                type: 'text',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },

            {
                name: 'StockLevel',
                label: 'Na stanju',
                type: 'text',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'StockLevelAlert',
                label: 'Upozorenje za magacin (komada)',
                type: 'text',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                type: 'spacer',
            },
            {
                name: 'Volume',
                label: 'Kubikaža',
                type: 'text',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },

            {
                name: 'Weight',
                label: 'Težina',
                type: 'text',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'QuantityInSet',
                label: 'Komada u setu',
                type: 'text',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },

            {
                type: 'spacer',
            },
            {

                name: 'YouTubeId',
                label: 'YouTube ID',
                type: 'text',
                width: {
                    desktop: 2,
                    mobile: 12
                }

            },
            {
                type: 'spacer',
            },
            {
                name: 'Description',
                label: 'Opis artikla',
                type: 'html',
                multilang: true,

                width: {
                    desktop: 12,
                    mobile: 12
                }

            },
            {
                type: 'spacer',
            }, {
                name: 'SendNewsletter',
                label: 'Pošalji newsletter',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            }, {
                type: 'spacer',
            },

        ],
        linkedFields: [
            {
                linkedCollection: 'categories',
                name: 'Breadcrumb[0]',
                label: 'Category',
                type: 'select',
                values: [],
                renderItems: (collection) => {
                    return collection.map((item) => {
                        return (
                            {
                                name: item.Alias,
                                value: item.Breadcrumb
                            }
                        )
                    });
                },
                additionalAction: () => {

                },
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                linkedCollection: 'categories',
                name: 'Breadcrumb[1]',
                label: 'Additional Category',
                type: 'select',
                values: [],
                renderItems: (collection) => {
                    return collection.map((item) => {
                        return (
                            {
                                name: item.Alias,
                                value: item.Breadcrumb
                            }
                        )
                    });
                },
                additionalAction: () => {

                },
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },

            {
                linkedCollection: 'attributes',
                name: 'Attributes',
                label: 'Atributi',
                type: 'select',
                multiselect: true,
                values: [],
                renderItems: (collection) => {
                    return [{
                        name: 'None',
                        value: '0'
                    }, ...collection.map((item) => {
                        return (
                            {
                                name: item.Name.ba,
                                value: item._id
                            }
                        )
                    })];
                },
                additionalAction: () => {

                },
                width: {
                    desktop: 3,
                    mobile: 12
                }
            }, {
                linkedCollection: 'units',
                name: 'OrderUnit',
                label: 'Jedinica mjere',
                type: 'select',
                values: [],
                renderItems: (collection) => {
                    return collection.map((item) => {
                        return (
                            {
                                name: item.name.ba,
                                value: item.shortName.ba
                            }
                        )
                    });
                },
                additionalAction: () => {

                },
                width: {
                    desktop: 3,
                    mobile: 12
                }



            }
        ]
    },

    {
        title: 'Korisnik',
        subtitle: 'Dodaj/Izmjeni korisnika',
        link: '/users',
        collection: 'users',
        multilang: false,
        fields: [
            {
                name: 'User.Name',
                label: 'Ime',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'User.EMail',
                label: 'Email',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'CustomerGroup',
                label: 'Korisnička grupa',
                type: 'select',
                values: [{ name: 'Fizičko lice', value: 'PhysicalPerson' }, { name: 'Pravno lice', value: 'LegalPerson' }],
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },

            {
                name: 'IP',
                label: 'IP Adresa',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'Coordinates',
                label: 'GPS Koordinate',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            }, {
                name: 'User.PasswordsHistory[0]',
                label: 'Lozinka',
                type: 'password',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'UserRegion',
                label: 'Regija korisnika',
                type: 'select',
                values: [{ name: '1', value: '1' }, { name: '2', value: '2' }, { name: '3', value: '3' }, { name: '4', value: '4' }, { name: '5', value: '5' }, { name: '6', value: '6' }, { name: '7', value: '7' }, { name: '8', value: '8' }, { name: '9', value: '9' }, { name: '10', value: '10' }],
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'Alias',
                label: 'Redni broj korisnika',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'TimeToPay',
                label: 'Odloženo plaćanje',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },

            {
                name: 'EnableGPSBlock',
                label: 'Omogući GPS blokiranje',
                type: 'checkbox',
                multilang: false,
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },

            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Coordinates',
                label: 'Mapa',
                type: 'map',
                width: {
                    desktop: 6,
                    mobile: 12
                }

            },
            {
                type: 'spacer'
            },
            {
                name: 'EmailVerified',
                label: 'Verifikovan email',
                type: 'checkbox',
                multilang: false,
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                name: 'IsSalesManager',
                label: 'Komercijalista',
                type: 'checkbox',
                multilang: false,
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                name: 'SubscribeToNewsletter',
                label: 'Prijavljen na newsletter',
                type: 'checkbox',
                multilang: false,
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },

            {
                type: 'spacer'
            },

            {
                type: 'title',
                text: 'Adresa za obračun'
            },

            {
                name: 'BillingAddress.FirstName',
                label: 'Ime',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.LastName',
                label: 'Prezime',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.Street',
                label: 'Ulica i broj',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.City',
                label: 'Grad',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 5,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.Zipcode',
                label: 'Poštanski broj',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 1,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.Company',
                label: 'Firma',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.EMail',
                label: 'EMail',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.Phone',
                label: 'Telefon',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.JIB',
                get label() { return getSiteConfig().company.TaxIdLabel || 'JIB'; },
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.PDV',
                label: 'PDV',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.MB',
                label: 'MB',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'BillingAddress.TaxPayer',
                label: 'Obavezik PDV-a',
                type: 'select',
                values: [
                    {
                        name: 'NE',
                        value: '0'
                    }, {
                        name: 'DA',
                        value: '1'
                    }
                ],
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },



            {
                type: 'spacer'
            },




            {
                type: 'title',
                text: 'Adresa za isporuku'
            },

            {
                name: 'ShippingAddress.FirstName',
                label: 'Ime ili naziv firme',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.LastName',
                label: 'Prezime ili poslovna jedinica',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.Street',
                label: 'Ulica i broj',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            }, {
                name: 'ShippingAddress.City',
                label: 'Grad',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 5,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.Zipcode',
                label: 'Poštanski broj',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 1,
                    mobile: 12
                }
            },

            {
                name: 'ShippingAddress.EMail',
                label: 'EMail',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'ShippingAddress.Phone',
                label: 'Telefon',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },


        ],
        linkedFields: []

    }, {
        title: 'Kategorija',
        subtitle: 'Dodaj/Izmjeni kategoriju',
        link: '/categories',
        collection: 'categories',
        multilang: true,

        fields: [
            {
                name: 'Image',
                label: 'Slika',
                type: 'file',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Alias',
                label: 'Alias',
                type: 'text',
                multilang: false,
                generateAlias: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                name: 'Name',
                label: 'Naziv',
                type: 'text',
                multilang: true,

                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                name: 'Position',
                label: 'Pozicija',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'IsVisible',
                label: 'Vidljiva',
                type: 'checkbox',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },

        ],
        linkedFields: [
            {
                linkedCollection: 'categories',
                name: 'ParentCategory',
                label: 'Kategorija',
                type: 'select',
                values: [],
                renderItems: (collection) => {
                    return collection.map((item) => {
                        return (
                            {
                                name: item.Alias,
                                value: item._id
                            }
                        )
                    });
                },
                additionalAction: () => {

                },
                width: {
                    desktop: 3,
                    mobile: 12
                }
            }

        ]

    },
    {
        title: 'Atribut',
        subtitle: 'Dodaj/Izmjeni atribut',
        link: '/attributes',
        collection: 'attributes',
        multilang: true,
        fields: [
            {
                name: 'Alias',
                label: 'Alias',
                type: 'text',
                multilang: false,
                generateAlias: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                name: 'Name',
                label: 'Naziv',
                type: 'text',
                multilang: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                name: 'Values',
                label: 'Vrijednosti',
                type: 'tags',
                multilang: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },

        ],
        linkedFields: [


        ]

    },
    {
        title: 'Novosti',
        subtitle: 'Dodaj/Izmjeni novost',
        link: '/news',
        collection: 'news',
        multilang: true,
        fields: [
            {
                name: 'Image',
                label: 'Slika',
                type: 'file',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Alias',
                label: 'Alias',
                type: 'text',
                multilang: false,
                generateAlias: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                name: 'Title',
                label: 'Naslov',
                type: 'text',
                multilang: true,

                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                name: 'ShortDescription',
                label: 'Kratak opis',
                type: 'text-multiline',
                multilang: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'offset',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'Content',
                label: 'Sadrzaj',
                type: 'html',
                multilang: true,
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'IsVisible',
                label: 'Aktivna',
                type: 'checkbox',
                width: {
                    desktop: 12,
                    mobile: 12
                }

            },
            {
                type: 'spacer'
            },

        ],
        linkedFields: [


        ]

    },
    {
        title: 'Galerija',
        subtitle: 'Izmjeni galeriju',
        link: '/gallery',
        collection: 'gallery',

        fields: [
            {
                name: 'Images',
                label: 'Slike',
                type: 'file-multiple',
                multilang: false,
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },

        ],
        linkedFields: [


        ]

    },

    {
        title: 'Product type',
        subtitle: 'Change category',
        link: '/product-types',
        collection: 'productTypes',

        fields: [
            {
                name: 'alias',
                label: 'Alias',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'name',
                label: 'Name',
                type: 'text',

                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'position',
                label: 'Position',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 1,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },
            {
                name: '_attribute',
                label: 'Select attribute to edit',
                type: 'select',
                values: [],
                additionalAction: (scope, value) => {
                    let fields = scope.state.fields;
                    let newFields = [];

                    let found = false;
                    for (let i = 0; i < fields.length; i++) {

                        if ((fields[i].type === 'title' && !found) || i === fields.length - 1) {

                            if (i === fields.length - 1) {
                                newFields.push(fields[i]);
                            }

                            newFields.push({
                                type: 'title',
                                text: value
                            }
                            );


                            newFields.push({
                                name: 'attributes.' + value + ".alias",
                                label: 'Alias',
                                type: 'text',
                                multilang: false,
                                width: {
                                    desktop: 6,
                                    mobile: 12
                                }
                            }
                            );

                            newFields.push({
                                name: 'attributes.' + value + ".name",
                                label: 'Name',
                                type: 'text',

                                width: {
                                    desktop: 6,
                                    mobile: 12
                                }
                            }
                            );

                            for (let j = 0; j < scope.state.initialValues.attributes[value].values.length; j++) {

                                newFields.push({
                                    name: 'attributes.' + value + ".values[" + j + "].value",
                                    label: 'Item[' + j + "] Value",
                                    type: 'text',
                                    multilang: false,
                                    width: {
                                        desktop: 3,
                                        mobile: 12
                                    }
                                }

                                );

                                newFields.push({
                                    name: 'attributes.' + value + ".values[" + j + "].name",
                                    label: 'Item[' + j + "] Name",
                                    type: 'text',

                                    width: {
                                        desktop: 3,
                                        mobile: 12
                                    }
                                }

                                );

                                newFields.push({
                                    type: 'offset',
                                    width: {
                                        desktop: 12,
                                        mobile: 12
                                    }
                                })

                            }


                            newFields.push({
                                type: 'spacer',
                            }
                            );


                            found = true;
                            if (i !== fields.length - 1) {

                                newFields.push(fields[i]);
                            }

                        } else {
                            newFields.push(fields[i]);
                        }

                    }


                    scope.setState({ fields: newFields })

                },
                renderItems: (data) => {
                    return Object.values(data.attributes).map((item) => {
                        return (
                            {
                                name: item.alias,
                                value: item.alias
                            }
                        )
                    })
                },
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            }

            , {
                type: 'button',
                text: 'New attribute',
                width: {
                    desktop: 12,
                    mobile: 12
                },

                onClick: (scope) => {
                    scope.props.handlePrompt({
                        text: 'Enter attribute alias',
                        callback: (value) => {
                            let fields = scope.state.fields;
                            let newFields = [];

                            let found = false;
                            for (let i = 0; i < fields.length; i++) {

                                if ((fields[i].type === 'title' && !found) || i === fields.length - 1) {

                                    if (i === fields.length - 1) {
                                        newFields.push(fields[i]);
                                    }

                                    newFields.push({
                                        type: 'title',
                                        text: value
                                    }
                                    );


                                    newFields.push({
                                        name: 'attributes.' + value + ".alias",
                                        label: 'Alias',
                                        type: 'text',
                                        multilang: false,
                                        width: {
                                            desktop: 6,
                                            mobile: 12
                                        }
                                    }
                                    );

                                    newFields.push({
                                        name: 'attributes.' + value + ".name",
                                        label: 'Name',
                                        type: 'text',

                                        width: {
                                            desktop: 6,
                                            mobile: 12
                                        }
                                    }
                                    );


                                    newFields.push({
                                        type: 'button',
                                        text: 'Add value',
                                        width: {
                                            desktop: 12,
                                            mobile: 12
                                        },

                                        onClick: (scope) => {
                                            let f = scope.state.fields;
                                            let nF = [];
                                            for (let j = 0; j < f.length; j++) {
                                                if (f[j].name === 'attributes.' + value + ".name") {


                                                    let k = 0;
                                                    for (let l = 0; l < f.length; l++) {
                                                        if (f[l].name && f[l].name.indexOf('attributes.' + value + ".values") !== -1) {
                                                            k++;
                                                        }
                                                    }

                                                    k /= 2;
                                                    console.log(k);

                                                    nF.push(f[j]);

                                                    nF.push({
                                                        name: 'attributes.' + value + ".values[" + (k) + "].value",
                                                        label: 'Item[' + (k) + "] Value",
                                                        type: 'text',
                                                        multilang: false,
                                                        width: {
                                                            desktop: 3,
                                                            mobile: 12
                                                        }
                                                    }

                                                    );

                                                    nF.push({
                                                        name: 'attributes.' + value + ".values[" + (k) + "].name",
                                                        label: 'Item[' + (k) + "] Name",
                                                        type: 'text',

                                                        width: {
                                                            desktop: 3,
                                                            mobile: 12
                                                        }
                                                    });

                                                    nF.push({
                                                        type: 'offset',
                                                        width: {
                                                            desktop: 12,
                                                            mobile: 12
                                                        }
                                                    })

                                                } else {
                                                    nF.push(f[j]);
                                                }
                                            }

                                            scope.setState({
                                                fields: nF
                                            })

                                        },
                                    })


                                    newFields.push({
                                        type: 'spacer',
                                    }
                                    );


                                    found = true;
                                    if (i !== fields.length - 1) {

                                        newFields.push(fields[i]);
                                    }

                                } else {
                                    newFields.push(fields[i]);
                                }

                            }


                            scope.setState({ fields: newFields })
                        }
                    })
                }

            },
            {
                type: 'spacer'
            }
        ],
        linkedFields: [

        ]
    },
    {
        title: 'Dostava',
        subtitle: 'Dodaj/Izmjeni dostavu',
        link: '/delivery-methods',
        collection: 'deliveryMethods',

        fields: [
            {
                name: 'alias',
                label: 'Alias',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 5,
                    mobile: 12
                }
            },
            {
                name: 'name',
                label: 'Ime',
                type: 'text',

                width: {
                    desktop: 5,
                    mobile: 12
                }
            },
            {
                name: 'price',
                label: 'Cijena',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'maxWeight',
                label: 'Max težina',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },

            {
                name: 'maxVolume',
                label: 'Max kubikaža',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },


            {
                type: 'spacer'
            }
        ],
        linkedFields: []
    },

    {
        title: 'Slide',
        subtitle: 'Change slide',
        link: '/slides',
        collection: 'slides',

        fields: [

            {
                name: 'Image',
                label: 'Slika',
                type: 'file',
                multilang: false,
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                name: 'Video',
                label: 'Video (MP4, do 60 MB) - prikazuje se umjesto slike',
                type: 'file',
                multilang: false,
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },


        ],
        linkedFields: []

    },
    {
        title: 'Banner',
        subtitle: 'Dodaj/Izmjeni baner',
        link: '/banners',
        collection: 'banners',
        multilang: true,
        fields: [

            {
                name: 'Image',
                label: 'Image',
                type: 'file',
                multilang: false,
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },

            {
                type: 'spacer'
            },
            {
                name: 'Title',
                label: 'Naslov',
                type: 'text',
                multilang: true,

                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'Subtitle',
                label: 'Podnaslov',
                type: 'text',
                multilang: true,

                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },
            {
                name: 'Link',
                label: 'Link',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },


        ],
        linkedFields: []

    },

    {
        title: 'Settings',
        subtitle: 'Change settings',
        link: '/settings',
        collection: 'settings',
        multilang: false,
        fields: [
            {
                name: 'footerText',
                label: 'Footer Text',
                type: 'text-multiline',

                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'address',
                label: 'Address',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'phone',
                label: 'Phone',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'email',
                label: 'Email',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },


        ],
        linkedFields: []

    },

    {
        title: 'Pop Up',
        subtitle: 'Change Pop Up',
        link: '/popup',
        collection: 'popup',
        multilang: false,
        fields: [
            {
                name: 'Title',
                label: 'Title',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'Subtitle',
                label: 'Subtitle',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'Text',
                label: 'Text',
                type: 'text',
                multilang: false,
                width: {
                    desktop: 3,
                    mobile: 12
                }
            },
            {
                name: 'Image',
                label: 'Image',
                type: 'file',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'Background',
                label: 'Background',
                type: 'file',
                multilang: false,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },


        ],
        linkedFields: []

    },
    {
        title: 'Stranice',
        subtitle: 'Izmjena stranice',
        link: '/pages',
        collection: 'pages',
        multilang: true,
        fields: [

            {
                name: 'title',
                label: 'Naslov',
                type: 'text',
                multilang: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'alias',
                label: 'Alias',
                type: 'text',
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                type: 'spacer'
            },

            {
                name: 'content',
                label: 'Tekst',
                type: 'html',
                multilang: true,
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },

            {
                type: 'spacer'
            },


        ],
        linkedFields: []

    },
    {
        title: 'Jedinice mjere',
        subtitle: 'Izmjena',
        link: '/units',
        collection: 'units',
        multilang: true,
        fields: [

            {
                name: 'name',
                label: 'Ime',
                type: 'text',
                multilang: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },
            {
                name: 'shortName',
                label: 'Skracenica',
                type: 'text',
                multilang: true,
                width: {
                    desktop: 6,
                    mobile: 12
                }
            },

            {
                type: 'spacer'
            },


        ],
        linkedFields: []

    },
    {
        title: 'Podesavanje',
        subtitle: '',
        link: '/config',
        collection: 'config',

        multilang: false,
        fields: [
            {
                name: 'priceList1',
                label: 'Neulogovani kupci vide cijenu MPC1 (isključeno: MPC0)',
                type: 'checkbox',
                width: {
                    desktop: 4,
                    mobile: 12
                }
            },

            {
                name: 'PricesVisible',
                label: 'Prikazati cijene',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'ArticlesVisible',
                label: 'Prikazati artikle',
                type: 'checkbox',
                width: {
                    desktop: 2,
                    mobile: 12
                }
            },
            {
                name: 'FreeShippingFromPhysicalPerson',
                label: 'Besplatna dostava od [MP]',
                type: 'text',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },
            {
                name: 'FreeShippingFromLegalPerson',
                label: 'Besplatna dostava od [VP]',
                type: 'text',
                width: {
                    desktop: 12,
                    mobile: 12
                }
            },

            {
                type: 'title',
                text: 'VP Narudzbe'
            },

            ...vpOrderEmailFields,
            {
                type: 'title',
                text: 'MP Narduzbe'
            },

            ...mpOrderEmailFields,

            {
                type: 'title',
                text: 'Novi kupci'
            },
            ...newCustomerEmailFields,

            {
                type: 'title',
                text: 'Podaci firme (sajt, mailovi, faktura)'
            },
            ...companyFields

        ],
        linkedFields: [

        ]
    },
]


let listPages = [
    {
        title: 'Stranice',
        subtitle: 'Lista stranica',
        link: '/pages',
        collection: 'pages',
        searchFields: ['Alias', 'Title'],
        itemFields: [
            {
                name: "alias",
                label: "Alias",
                type: "text",
            }, {
                name: "title.ba",
                label: "Naslov",
                type: "text",
            },
        ],

    },
    {
        title: 'Jedinice mjere',
        subtitle: 'Lista',
        link: '/units',
        collection: 'units',
        searchFields: ['Alias', 'Title'],
        itemFields: [
            {
                name: "name.ba",
                label: "Ime",
                type: "text",
            },
        ],

    },

    {
        title: 'Admins',
        subtitle: 'Lista admina',
        link: '/admins',
        collection: 'admins',
        searchFields: ['username', 'userRole'],
        itemFields: [
            {
                name: "username",
                label: "Username",
                type: "text",
            },
            {
                name: 'userRole',
                label: "Tip",

                type: "text"
            },
        ],
    },
    {
        title: 'Atributi',
        subtitle: 'Lista atributa',
        link: '/attributes',
        collection: 'attributes',
        searchFields: ['Alias', 'Name'],
        itemFields: [
            {
                name: "Alias",
                label: "Alias",
                type: "text",
            },
            {
                name: 'Name.ba',
                label: "Naziv",

                type: "text"
            },
        ],
    }, {
        title: 'Novosti',
        subtitle: 'Lista novosti',
        link: '/news',
        haveImage: true,
        collection: 'news',
        searchFields: ['Alias', 'Title'],
        itemFields: [
            {
                name: 'Image',
                type: "image",
                disableSort: true
            }, {
                name: "Alias",
                label: "Alias",
                type: "text",
            },
            {
                name: 'Title.ba',
                label: "Naslov",

                type: "text"
            },
        ],
        sortOptions: [
            {
                name: 'Po naslovu',
                field: 'Title',
                sort: 1
            },
        ]
    }, {
        title: 'Proizvodi',
        subtitle: 'Lista proizvoda',
        link: '/products',
        haveImage: true,
        multilang: true,
        collection: 'products',
        searchFields: ['Alias', 'Name'],
        itemFields: [
            {
                name: 'Image',
                type: "image",
                disableSort: true
            }, {
                name: "Alias",
                label: "Šifra proizvoda",
                type: "text",
            },
            {
                name: 'Name.ba',
                label: "Naziv",

                type: "text"
            },
            {
                name: "mpc[0]",
                label: "MPC0",

                type: "price",
                allowEdit: true
            },
            {
                name: "mpc[1]",
                label: "MPC1",

                type: "price",
                allowEdit: true
            },
            {
                name: "vpc[0]",
                label: "VPC0",

                type: "price",
                allowEdit: true
            },
            {
                name: "vpc[1]",
                label: "VPC1",

                type: "price",
                allowEdit: true
            },
            {
                name: "vpc[2]",
                label: "VPC2",

                type: "price",
                allowEdit: true
            },
            {
                name: "vpc[3]",
                label: "VPC3",

                type: "price",
                allowEdit: true
            },
            {
                name: "vpc[4]",
                label: "VPC4",

                type: "price",
                allowEdit: true
            },
            {
                name: "vpc[5]",
                label: "VPC5",

                type: "price",
                allowEdit: true
            },
            {
                name: "vpc[6]",
                label: "VPC6",

                type: "price",
                allowEdit: true
            },
            {
                name: "vpc[7]",
                label: "VPC7",

                type: "price",
                allowEdit: true
            },
            {
                name: "StockLevel",
                label: "Stanje",

                type: "number",
                allowEdit: true

            }
        ],
        sortOptions: [
            {
                name: 'Po imenu',
                field: 'Name.de',
                sort: 1
            },
            {
                name: 'MPC - ascending',
                field: 'price',
                sort: 1
            },
            {
                name: 'Price - descending',
                field: 'price',
                sort: -1
            },
            {
                name: 'Stock - ascending',
                field: 'StockLevel',
                sort: 1
            },
            {
                name: 'Stock - descending',
                field: 'StockLevel',
                sort: -1
            }
        ]
    },
    {
        title: 'Korisnici',
        subtitle: 'Lista korisnika',
        link: '/users',
        haveImage: false,
        collection: 'users',
        searchFields: ['Alias', 'User.Name', 'User.EMail', 'Alias'],
        itemFields: [
            /*{
                name: '_id',
                type: "text"
            }*/,
            {
                name: 'Alias',
                label: 'Redni br.',
                type: "text"
            },
            {
                name: 'UserRegion',
                label: 'Regija',
                type: "text"
            },

            {
                name: 'User.Name',
                label: 'Name',
                type: "text"
            },
            {
                name: 'User.EMail',
                label: 'EMail',
                type: "text"
            },
            {
                name: 'BillingAddress.City',
                label: 'Grad',
                type: "text"
            },

            {
                name: 'CustomerGroup',
                label: 'Korisnička grupa',
                type: "text"
            },
            , {
                name: 'priceList',
                type: "select",
                values: [
                    {
                        name: 'VPC0',
                        value: '0'
                    },
                    {
                        name: 'VPC1',
                        value: '1'
                    },
                    {
                        name: 'VPC2',
                        value: '2'
                    },
                    {
                        name: 'VPC3',
                        value: '3'
                    },
                    {
                        name: 'VPC4',
                        value: '4'
                    },
                    {
                        name: 'VPC5',
                        value: '5'
                    },
                    {
                        name: 'VPC6',
                        value: '6'
                    },
                    {
                        name: 'VPC7',
                        value: '7'
                    },

                ],
                label: "Cijenovnik",
                allowEdit: true

            },
        ],
    }, {
        title: 'Kategorije',
        subtitle: 'Lista kategorija',
        link: '/categories',
        haveImage: true,
        collection: 'categories',
        searchFields: ['Alias', 'Name'],
        itemFields: [
            {
                name: 'Image',
                type: "image",
                disableSort: true,

            }, {
                name: 'Alias',
                type: "text",
                label: "Alias"
            },
            {
                name: 'Breadcrumb',
                type: "text",
                label: "Breadcrumb"

            },
            {
                name: 'Position',
                type: "text",
                label: 'Position'
            }
        ],

    }, {
        title: 'Popusti',
        subtitle: 'Lista kategorija',
        link: '/priceList/:uid',
        collection: 'priceList',
        searchFields: ['Alias', 'Name'],
        disableEdit: true,
        disableDelete: true,
        itemFields: [
            {
                name: 'Alias',
                type: "text",
                label: "Alias"
            },
            {
                name: 'Breadcrumb',
                type: "text",
                label: "Breadcrumb"

            }, {
                name: 'priceList',
                type: "select",
                values: [
                    {
                        name: 'VPC0',
                        value: '0'
                    },
                    {
                        name: 'VPC1',
                        value: '1'
                    },
                    {
                        name: 'VPC2',
                        value: '2'
                    },
                    {
                        name: 'VPC3',
                        value: '3'
                    },
                    {
                        name: 'VPC4',
                        value: '4'
                    },
                    {
                        name: 'VPC5',
                        value: '5'
                    },
                    {
                        name: 'VPC6',
                        value: '6'
                    },
                    {
                        name: 'VPC7',
                        value: '7'
                    },


                ],
                label: "Cijenovnik",
                allowEdit: true

            },
        ],

    }, {
        title: 'Dostave',
        subtitle: 'Lista dostava',
        link: '/delivery-methods',
        haveImage: false,
        collection: 'deliveryMethods',
        searchFields: ['alias', 'name'],
        itemFields: [
            {
                name: 'alias',
                type: "text",
                label: "Alias"

            },
            {
                name: 'name',
                type: "text",
                label: "Name"

            },
            {
                name: 'price',
                type: "price",
                label: "Price"

            },
        ],
    },
    {
        title: 'Slider na početnoj',
        subtitle: 'Lista slajdova',
        link: '/slides',
        haveImage: true,
        collection: 'slides',
        searchFields: [],
        itemFields: [
            {
                name: 'Image',
                type: "image"
            },
        ],
    },
    {
        title: 'Baneri',
        subtitle: 'Lista banera',
        link: '/banners',
        haveImage: true,
        collection: 'banners',
        searchFields: ['Title', 'Subtitle'],
        itemFields: [
            {
                name: 'Image',
                type: "image"
            }, {
                name: 'Title.ba',
                type: "text",
                label: 'Title'

            },
            {
                name: 'Subtitle.ba',
                type: "text",
                label: 'Subtitle'

            },
        ],
    },
    {
        title: 'Newsletters',
        subtitle: 'List of newsletters',
        link: '/newsletters',
        haveImage: true,
        collection: 'newsletters',
        searchFields: ['Title', 'Text'],
        itemFields: [
            {
                name: 'Title',
                type: "text"
            },

        ],
        sortOptions: [
            {
                name: 'Relevant',
                field: '_id',
                sort: -1
            }

        ]
    },
    {
        title: 'Popup',
        subtitle: 'List of popup',
        link: '/popup',
        haveImage: true,
        collection: 'popup',
        searchFields: ['Title', 'Subtitle'],
        itemFields: [
            {
                name: 'Image',
                type: "image"
            }, {
                name: 'Title',
                type: "text"
            },

        ],
        sortOptions: [
            {
                name: 'Relevant',
                field: '_id',
                sort: -1
            }

        ]
    }, {
        title: 'Kontakti',
        subtitle: 'Lista kontakata',
        link: '/contacts',
        collection: 'contacts',
        disableDelete: true,
        disableEdit: true,
        searchFields: ['EMail', 'Name'],
        itemFields: [
            {
                name: 'Name',
                label: 'Ime',
                type: "text"
            },
            {
                name: 'EMail',
                label: 'EMail',

                type: "text"
            }, {
                name: 'Subject',
                label: 'Naslov',

                type: "text"
            }, {
                name: 'Message',
                label: 'Poruka',

                type: "text"
            },

        ],
    },
    {
        title: 'Narudzbe',
        subtitle: 'Lista narudzbi',
        link: '/orders',
        collection: 'orders',
        disableDelete: true,
        searchFields: ['PayPalTransaction.transactions.invoice_number', 'BillingAddress.FirstName', 'BillingAddress.LastName', 'BillingAddress.Company'],
        itemFields: [
            {
                name: 'orderNumber',
                label: 'Br. narudžbe',
                type: "text"
            },
            {
                name: 'orderTime',
                label: 'Datum',

                type: "datetime",
                format: "DD.MM.YYYY"
            },

            {
                name: 'ShippingAddress.FirstName',
                label: 'Firma ili ime',
                type: "text"
            },
            {
                name: 'ShippingAddress.LastName',
                label: 'PJ / Prezime',

                type: "text"
            },
            {
                name: 'ShippingAddress.City',
                label: 'Grad',

                type: "text"
            },
            {
                name: 'DeliveryMethod.name',
                label: 'Dostava',

                type: "text"
            },
            {
                name: 'BillingMethod',
                label: 'Način plaćanja',

                type: "text"
            },

            {
                name: 'total',
                label: 'Ukupno',
                type: "price"
            },

            {
                name: 'Payed',
                label: 'Plaćeno',
                type: "price",
                allowEdit: true
            },

            {
                name: 'ToPay',
                label: 'Dug',
                type: "price"
            },
            {
                name: 'Status',
                label: 'Status',
                type: "text"
            },
            {
                name: 'timeToPay',
                label: 'Valua plaćanja',

                type: "datetime",
                format: "DD.MM.YYYY"
            },

        ],
        sortOptions: [
            {
                name: 'Relevant',
                field: '_id',
                sort: -1
            }

        ]
    }, {
        title: 'User orders',
        subtitle: 'List of orders',
        link: '/user-orders/:uid',
        collection: 'orders',
        disableDelete: true,
        searchFields: ['PayPalTransaction.transactions.invoice_number', 'BillingAddress.FirstName', 'BillingAddress.LastName', 'BillingAddress.Company'],
        itemFields: [
            {
                name: 'orderNumber',
                label: 'Br. narudžbe',
                type: "text"
            },
            {
                name: 'orderTime',
                label: 'Datum',

                type: "datetime",
                format: "DD.MM.YYYY"
            },

            {
                name: 'ShippingAddress.FirstName',
                label: 'Firma ili ime',
                type: "text"
            },
            {
                name: 'ShippingAddress.LastName',
                label: 'PJ / Prezime',

                type: "text"
            },
            {
                name: 'ShippingAddress.City',
                label: 'Grad',

                type: "text"
            },
            {
                name: 'DeliveryMethod.name',
                label: 'Dostava',

                type: "text"
            },
            {
                name: 'BillingMethod',
                label: 'Način plaćanja',

                type: "text"
            },

            {
                name: 'total',
                label: 'Ukupno',
                type: "price"
            },

            {
                name: 'Payed',
                label: 'Plaćeno',
                type: "price",
                allowEdit: true
            },

            {
                name: 'ToPay',
                label: 'Dug',
                type: "price"
            },
            {
                name: 'Status',
                label: 'Status',
                type: "text"
            },
            {
                name: 'timeToPay',
                label: 'Valua plaćanja',

                type: "datetime",
                format: "DD.MM.YYYY"
            },



        ],
        sortOptions: [
            {
                name: 'Relevant',
                field: '_id',
                sort: -1
            }

        ]
    }, {
        title: 'Partneri',
        subtitle: 'Lista partnera',
        link: '/partners',
        collection: 'partners',
        searchFields: [],
        haveImage: true,
        itemFields: [

            {
                name: 'Image',
                label: 'Slika',
                type: "image",
                disableSort: true

            },
            {
                name: 'Name',
                label: 'Ime',
                type: "text"
            },
            {
                name: 'Position',
                label: 'Pozicija',
                allowEdit: true,
                type: "number"
            },

        ],
        sortOptions: [
            {
                name: 'Relevant',
                field: '_id',
                sort: -1
            }

        ]
    },


];


class Routes extends Component {

    componentDidMount() {
        /*const unlisten = history.listen((location, action) => {
            this.props.handleMenu(null);
        });
        */
    }

    render() {
        return (
            <Router >
                <div>

                    <GoogleMapScript API_KEY="AIzaSyAAqbIo7N0_Rpwtay3-CWzo5gkfpgWZ4to" />

                    <Switch className="react-switch">

                        {this.props.uData && this.props.uData.userRole == 'super' ?

                            <Route
                                path="/"
                                exact
                                render={(...renderProps) => (
                                    <HomePage {...renderProps} {...this.props} />
                                )}
                            />

                            :
                            !this.props.uData ?
                                <Route
                                    path="/"
                                    exact
                                    render={(...renderProps) => (
                                        <LoginPage {...renderProps} {...this.props} />
                                    )}
                                />

                                : null


                        }

                        <Route
                            path="/login"
                            exact
                            render={(...renderProps) => (
                                <LoginPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/order/:id"
                            exact
                            render={(...renderProps) => (
                                <Order {...renderProps} {...this.props} />
                            )}
                        />

                        {
                            listPages.map((page, idx) => {
                                //console.log(page.link, (this.props.uData && (this.props.uData.userRole == 'super' || page.link == '/orders' || (this.props.uData.userRole == 'special' && page.link == '/products') || (this.props.uData.userRole == 'simple' && (page.link == '/users' || page.link == '/priceList/:uid')))))
                                if (this.props.uData && (this.props.uData.userRole == 'super' || page.link == '/orders' || page.link == '/user-orders/:uid' || (this.props.uData.userRole == 'special' && (page.link == '/products' || page.link == '/users' || page.link == '/priceList/:uid')) || (this.props.uData.userRole == 'simple' && (page.link == '/users' || page.link == '/priceList/:uid')))) {

                                    return (

                                        <Route
                                            path={page.link}
                                            exact
                                            render={(...renderProps) => (
                                                <ListPage {...page} {...renderProps} {...this.props} />
                                            )}
                                        />



                                    )
                                }

                            })

                        }

                        {
                            listPages.map((page, idx) => {
                                //console.log(page.link, (this.props.uData && (this.props.uData.userRole == 'super' || page.link == '/orders' || (this.props.uData.userRole == 'special' && page.link == '/products') || (this.props.uData.userRole == 'simple' && (page.link == '/users' || page.link == '/priceList/:uid')))))
                                if (this.props.uData && ((this.props.uData.userRole == 'special' && page.link == '/products') || (this.props.uData.userRole == 'simple' && page.link == '/users'))) {
                                    return (
                                        <Route
                                            path={'/'}
                                            exact
                                            render={(...renderProps) => (
                                                <ListPage {...page} {...renderProps} {...this.props} />
                                            )}
                                        />
                                    )
                                }
                            })
                        }

                        {
                            formPages.map((page, idx) => {
                                if (this.props.uData && (this.props.uData.userRole == 'super' || page.link == '/orders' || (this.props.uData.userRole == 'special' && (page.link == '/products' || page.link == '/users' || page.link == '/priceList/:uid')) || (this.props.uData.userRole == 'simple' && (page.link == '/users' || page.link == '/priceList/:uid'))))
                                    return (

                                        <Route
                                            path={`${page.link}/:id`}
                                            exact
                                            render={(...renderProps) => (
                                                <FormPage {...page} {...renderProps} {...this.props} />
                                            )}
                                        />



                                    )

                            })
                        }




                    </Switch>
                </div>
            </Router >
        );
    }
}

export default Routes;